define('uikit/elements/divider',['require','exports','module','underscore','marionette','../mixins/component.mixin','templates','../channel'],function(require, exports, module){
  var _ = require('underscore');
  var Mn = require('marionette');
  var ComponentMixin = require('../mixins/component.mixin');
  var Templates = require('templates');
  var channel = require('../channel');

  var Divider = Mn.ItemView.extend(ComponentMixin).extend({

    className: 'ui divider',

    attributes: {
      'role': 'separator'
    },

    template: Templates.App['divider'],

    options: {
      horizontal: false,
      vertical: false,
      section: false,
      header: false,
      hidden: false,
      clearing: false,
      inverted: false,
      fitted: false,
      icon: '',
      text: '',
      uptight: false
    },

    forceUpdate: {
      text: true,
      icon: true
    },

    updateAttributes: function() {
      this
          .addClass('horizontal', this.getBoolOption('horizontal'))
          .addClass('vertical', this.getBoolOption('vertical'))
          .addClass('section', this.getBoolOption('section'))
          .addClass('hidden', this.getBoolOption('hidden'))
          .addClass('header', this.getBoolOption('header'))
          .addClass('clearing', this.getBoolOption('clearing'))
          .addClass('inverted', this.getBoolOption('inverted'))
          .addClass('fitted', this.getBoolOption('fitted'))
          .addClass('uptight', this.getBoolOption('uptight'))
          ;
    }

  });
  channel.reply('divider', _.constant(Divider));
  module.exports = Divider;
});

